import React from "react";

// Bordered capability row: hover turns the row white and grows a royal
// left edge. Capability numbers from copy are intentionally not rendered.
export default function CapabilityRow({ title, body }) {
  return (
    <div className="group relative grid gap-2 sm:grid-cols-12 sm:gap-6 border-b border-line py-7 pl-5 pr-2 transition-colors duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] hover:bg-white">
      <span
        aria-hidden="true"
        className="absolute left-0 top-0 bottom-0 w-[3px] bg-royal origin-top scale-y-0 transition-transform duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-y-100"
      />
      <h3 className="sm:col-span-4 font-hanken font-bold text-xl text-ink tracking-[-0.015em]">
        {title}
      </h3>
      <p className="sm:col-span-8 text-[15px] leading-[1.68] text-steel">{body}</p>
    </div>
  );
}
